type SeenThingOption = {
    name: DidYouSeeThis.ThingsToSee
    color: string
    aliases: string[]
}

const SEEN_THING_OPTIONS: SeenThingOption[] = [
    { name: 'periska', color: '#ff0000', aliases: ['Plemenita periska', 'Plemenita periska - Pinna nobilis', 'Noble pen shell', 'Pinna nobilis'] },
    { name: 'obicnaPeriska', color: '#e1ff00', aliases: ['Periska', 'Periska - Pinna rudis', 'Pinnid', 'Pinna rudis'] },
    { name: 'kirnja', color: '#ff8000', aliases: ['Kirnja', 'Kirnja - Epinephelus marginatus', 'Dusky grouper', 'Epinephelus marginatus'] },
    {
        name: 'jezinac',
        color: '#00ff80',
        aliases: ['Iglasti jezinac', 'Iglicasti jezinac', 'Iglicasti jezinac - Centrostephanus longispinus', 'Hatpin urchin', 'Centrostephanus longispinus'],
    },
    { name: 'zupka', color: '#777777', aliases: ['Zupka', 'Zupka - Luria lurida', 'Luria lurida'] },
    { name: 'truba', color: '#ff00f7', aliases: ['Tritonova truba', 'Tritonova truba - Charonia spp', 'Charonia spp'] },
    { name: 'zlatica', color: '#ffcc00', aliases: ['Kirnja zlatica', 'Kirnja zlatica - Epinephelus costae', 'Goldblotch grouper', 'Epinephelus costae'] },
    { name: 'vatrenjaca', color: '#00ffea', aliases: ['Vatrenjaca', 'Vatrenjaca / riba paun', 'Vatrenjaca / riba paun - Pterois miles', 'Lionfish', 'Pterois miles'] },
    { name: 'drozd', color: '#00aaff', aliases: ['Drozd', 'Drozd - Labrus viridis', 'Emerald wrasse', 'Labrus viridis'] },
    {
        name: 'konjic',
        color: '#0066ff',
        aliases: ['Morski konjic', 'Morski konjic dugokljunic', 'Morski konjic dugokljunic - Hippocampus guttulatus', 'Hippocampus guttulatus'],
    },
    { name: 'hlap', color: '#5900ff', aliases: ['Hlap', 'Hlap - Homarus gammarus', 'European lobster', 'Homarus gammarus'] },
    { name: 'rak', color: '#c300ff', aliases: ['Americki plavi rak', 'Americki plavi rak - Callinestes sapidus', 'Blue crab', 'Callinestes sapidus'] },
    { name: 'gerardia', color: '#88ff00', aliases: ['Zuta gerardia', 'Zuta gerardia - Savalia savaglia', 'Gold coral', 'Savalia savaglia'] },
    { name: 'roznjaca', color: '#ff0090', aliases: ['Velika roznjaca', 'Velika roznjaca - Paramuricea clavata', 'Red gorgonian', 'Paramuricea clavata'] },
    { name: 'posidonija', color: '#ffffff', aliases: ['Plodovi posidonije', 'Plodovi posidonije - Posidonia oceanica', 'Posidonia', 'Posidonia oceanica'] },
]
const VALIDATION_ERRORS: Server.API.ValidationErrors = {
    LatitudeOutOfBounds: 0,
    LongitudeOutOfBounds: 1,
    ErrorReadingLatLong: 2,
    noCoordinates: 3,
    noEmail: 4,
    invalidEmail: 5,
    noSeenThing: 6,
}
const constants = {
    validationErrors: VALIDATION_ERRORS,
    seenThingOptions: SEEN_THING_OPTIONS,
    getSeenThingName: (seenThing: string): DidYouSeeThis.ThingsToSee | undefined => {
        const normalizedSeenThing = normalizeSeenThing(seenThing)
        return SEEN_THING_OPTIONS.find(
            (option) =>
                normalizeSeenThing(option.name) === normalizedSeenThing ||
                option.aliases.some((alias) => normalizeSeenThing(alias) === normalizedSeenThing)
        )?.name
    },
}
export default constants

const normalizeSeenThing = (seenThing: string) =>
    seenThing
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()
